export const LOGOUT = 'LOGOUT';
export const OPEN = 'OPEN';
export const SET_EVENT = 'SET_EVENT';
